export default function debounce(fn, delay, ...args) {
    let timeoutID = null;
    return function res() {
        clearTimeout(timeoutID);
        const that = this;
        timeoutID = setTimeout(() => {
            fn.apply(that, args);
        }, delay);
    };
}
